export var DashboardStatusEnum;
(function (DashboardStatusEnum) {
    DashboardStatusEnum["PENDING"] = "Pending";
    DashboardStatusEnum["READY_TO_START"] = "Ready To Start";
    DashboardStatusEnum["COMPLETE"] = "Complete";
    DashboardStatusEnum["NOT_REPORTING"] = "Not Reporting";
})(DashboardStatusEnum || (DashboardStatusEnum = {}));
